import React, { useState } from 'react';

const NAV_LINKS = [
  { label: 'Practices', href: '#networks' },
  { label: 'Brands', href: '#networks' },
  { label: 'Labs', href: '#networks' },
  { label: 'Software', href: '#networks' },
  { label: 'Company', href: 'mailto:nick@momorox.com' },
];

function NavLink({ href, children }) {
  const [hovered, setHovered] = useState(false);
  return (
    <a
      href={href}
      style={{ font: '400 13px Archivo,sans-serif', color: hovered ? '#dcedc2' : 'rgba(255,255,255,.72)', textDecoration: 'none', transition: 'color .18s ease' }}
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
    >
      {children}
    </a>
  );
}

export default function Navigation() {
  return (
    <nav style={{ position: 'sticky', top: 0, zIndex: 50, background: '#111', height: '60px', display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '0 20px' }}>
      <div style={{ display: 'flex', alignItems: 'center', gap: '32px' }}>
        <a href="/" style={{ display: 'block', lineHeight: 0, flexShrink: 0 }}>
          <img src="/assets/momorox-lockup.png" alt="MomoroX" style={{ height: '26px', width: 'auto', display: 'block' }} />
        </a>
        <div className="md-nav" style={{ display: 'none', gap: '24px' }}>
          {NAV_LINKS.map(({ label, href }) => (
            <NavLink key={label} href={href}>{label}</NavLink>
          ))}
        </div>
      </div>

      <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
        <SignInLink />
        <DemoLink />
      </div>

      <style>{`
        @media (min-width: 768px) {
          .md-nav { display: flex !important; }
        }
      `}</style>
    </nav>
  );
}

function SignInLink() {
  const [hovered, setHovered] = useState(false);
  return (
    <a
      href="https://concierge.momorox.com/login"
      className="mx-nav-signin"
      style={{ color: hovered ? '#fff' : 'rgba(255,255,255,.6)' }}
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
    >
      Sign in
    </a>
  );
}

function DemoLink() {
  const [hovered, setHovered] = useState(false);
  return (
    <a
      href="https://concierge.momorox.com"
      className="mx-nav-demo"
      style={{ background: hovered ? '#c5e19b' : '#dcedc2' }}
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
    >
      <span className="demo-full">Watch a Concierge demo</span>
      <span className="demo-short" style={{ display: 'none' }}>Try Concierge</span>
    </a>
  );
}
